import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const getWebProperties = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/webproperties`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const createWebProperty = async (bpid, webProperty) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/webproperties`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'POST',
    body: JSON.stringify(webProperty)
  }).then(res => API.generateResponse(res));
};

const getWebProperty = async (bpid, wpid) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/webproperties/${wpid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const deleteWebProperty = async (bpid, wpid) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/webproperties/${wpid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'DELETE'
  }).then(res => API.generateResponse(res));
};

const updateWebProperty = async (bpid, wpid, webProperty, updateMask) => {
  await API.refreshTokenWhenNeeded();

  const paths = `updateMask=${updateMask.join(',')}`;
  const body = {};
  updateMask.forEach(field => {
    body[field] = webProperty[field];
  });
  const url = `${baseUrl}/brandportals/${bpid}/webproperties/${wpid}?${paths}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'PATCH',
    body: JSON.stringify(body)
  }).then(res => API.generateResponse(res));
};

export { getWebProperties, createWebProperty, getWebProperty, deleteWebProperty, updateWebProperty };
